import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SidebarModule } from "primeng/sidebar";
import { PdfJsViewerModule } from "ng2-pdfjs-viewer";
import { PdfViewerComponent } from "./pdf-viewer.component";
import { TooltipModule } from "primeng/tooltip";

@NgModule({
  imports: [CommonModule, SidebarModule, PdfJsViewerModule, TooltipModule],
  declarations: [PdfViewerComponent],
  exports: [PdfViewerComponent],
})
export class PdfViewerModule {}
